<template>
  <v-layout align-start>
    <v-container>
      <v-row justify="center" align="center">
        <v-col cols="auto">
          <v-card max-width="500">
            <v-card-title>Cargar archivos</v-card-title>
            <v-text-field
              class="mx-3"
              label="Numero de asistencia"
              v-model="numeroAsistenciaCargar"
            ></v-text-field>
            <v-card-actions>
              <v-file-input
                v-model="filesCargadas"
                id="fileButtom"
                accept="image/*, .mp3"
                label="File input"
                multiple
                small-chips
                :show-size="1000"
                counter
                @change="cargarArchivos()"
              ></v-file-input>
              <v-btn
                :disabled="disabledCargarArchivos"
                class="mx-auto"
                rounded
                outlined
                elevation="3"
                color="blue"
                @click="subirArchivos()"
              >
                <i class="fas fa-cloud-upload-alt fa-2x"></i>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col cols="auto">
          <v-card height="auto" width="400px">
            <v-card-title>Descargar archivos</v-card-title>
            <v-row justify="center">
              <v-col cols="12" md="5">
                <v-text-field
                  class="mx-3"
                  v-model="numeroAsistenciaDescargar"
                  hint="NUMERO DE ASISTENCIA"
                  persistent-hint
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-btn
                  rounded
                  outlined
                  elevation="3"
                  color="blue"
                  @click="contarArchivosDescarga()"
                  ><i class="fas fa-cloud-download-alt fa-2x"></i
                ></v-btn>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col cols="12" v-if="imagenesPreview.length > 0">
          <v-sheet elevation="8">
            <v-btn @click="descargarZIP()">Descargar</v-btn>
            <v-slide-group
              v-model="model"
              class="pa-4"
              active-class="success"
              center-active
              show-arrows
            >
              <v-slide-item
                v-for="(item, i) in imagenesPreview"
                :key="i"
                v-slot="{ toggle }"
              >
                <v-card class="ma-4" height="200" width="150" @click="toggle">
                  <v-row class="fill-height" justify="center">
                    <v-scale-transition>
                      <v-img :src="item.url" @click="verImagen(item)"></v-img>
                    </v-scale-transition>
                  </v-row>
                </v-card>
              </v-slide-item>
            </v-slide-group>
          </v-sheet>
        </v-col>
        <v-col cols="12" v-if="filesDescargadasAudios.length > 0 || true">
          <v-sheet elevation="8">
            <v-slide-group
              v-model="model"
              class="pa-4"
              active-class="success"
              center-active
              show-arrows
            >
              <v-slide-item
                v-for="(item, i) in filesDescargadasAudios"
                :key="i"
                v-slot="{ toggle }"
              >
                <v-card class="ml-12" height="200" width="150" @click="toggle">
                  <v-row class="fill-height" justify="center">
                    <v-scale-transition>
                      <av-line
                        :line-width="2"
                        line-color="lime"
                        :audio-src="item.url"
                      ></av-line>
                    </v-scale-transition>
                  </v-row>
                </v-card>
              </v-slide-item>
            </v-slide-group>
          </v-sheet>
        </v-col>
      </v-row>
    </v-container>

    <div class="text-center">
      <v-dialog v-model="dialog" width="500">
        <v-card>
          <v-card-text class="pt-5">
            <v-img :src="imagenDialog"></v-img>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="dialog = false">
              Cerrar
            </v-btn>
            <v-btn
              color="error"
              text
              @click="dialogBorrarImagen = true"
              v-if="banderaEliminar"
            >
              Eliminar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <div class="text-center">
      <v-dialog v-model="dialogBorrarImagen" width="500">
        <v-card>
          <v-card-title class="headline grey lighten-2">
            Eliminar imagen
          </v-card-title>

          <v-card-text class="pt-5 title">
            ¿Está seguro de eliminar esta imagen?
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="dialogBorrarImagen = false">
              No
            </v-btn>
            <v-btn color="primary" text @click="eliminarImagen()">
              Si, seguro
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </v-layout>
</template>

<script>
import { storage } from "../main";

export default {
  data() {
    return {
      filesCargadas: [],
      filesDescargadas: [],
      filesDescargadasAudios: [],
      imagenesPreview: [],
      disabledCargarArchivos: true,
      disabledDescargarArchivos: true,
      numeroAsistenciaCargar: "",
      numeroAsistenciaDescargar: "",
      nombreImagen: "",
      model: null,
      listaArchivos: [],
      dialog: false,
      dialogBorrarImagen: false,
      imagenDialog: "",
      banderaEliminar: false,
      bandera: 0,
    };
  },
  methods: {
    cargarArchivos() {
      this.imagenesPreview = [];
      this.bandera = 1;
      if (this.filesCargadas.length > 0) {
        this.disabledCargarArchivos = false;
        for (var i = 0; i < this.filesCargadas.length; i++) {
          if (this.filesCargadas[i].type != "audio/mpeg") {
            this.imagenesPreview.push({
              url: URL.createObjectURL(this.filesCargadas[i]),
            });
          }
        }
      } else {
        this.disabledCargarArchivos = true;
      }
    },
    subirArchivos() {
      let me = this;
      for (var i = 0; i < me.filesCargadas.length; i++) {
        const storeRef = storage.child(
          me.numeroAsistenciaCargar + "/" + me.filesCargadas[i].name
        );
        const subir = storeRef
          .put(me.filesCargadas[i])
          .then(function(snapshot) {
            me.filesCargadas = [];
            me.imagenesPreview = [];
          });
      }
    },
    contarArchivosDescarga() {
      let me = this;
      if (me.numeroAsistenciaDescargar == "") {
        return;
      }
      const contador = storage
        .child(me.numeroAsistenciaDescargar)
        .listAll()
        .then(function(listAll) {
          var tamañoLista = listAll.items.length;
          for (var i = 0; i < tamañoLista; i++) {
            var auxPath = listAll.items[i].location.path;
            var splitPath = auxPath.split("/");
            me.listaArchivos[i] = splitPath[2];
          }
          tamañoLista = 0;
          auxPath = null;
          splitPath = [];
          me.descargarArchivos();
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    descargarArchivos() {
      let me = this;
      me.imagenesPreview = [];
      me.bandera = 0;
      for (let i = 0; i < me.listaArchivos.length; i++) {
        var auxListaArchivos = me.listaArchivos[i];
        let splitListaArchivos = auxListaArchivos.split(".");
        const storageRef = storage
          .child(me.numeroAsistenciaDescargar + "/" + me.listaArchivos[i])
          .getDownloadURL()
          .then(function(url) {
            if (splitListaArchivos[1] != "mp3") {
              me.imagenesPreview.push({
                name: me.listaArchivos[i],
                url: url,
              });
            } else {
              me.filesDescargadasAudios.push({
                name: me.listaArchivos[i],
                url: url,
              });
            }
          })
          .catch(function(error) {
            console.log("ERROR URL", error);
          });
      }
    },
    verImagen(item) {
      this.dialog = true;
      //mostrarlo en el dialog
      this.imagenDialog = item.url;
      this.nombreImagen = item.name;
      if (this.bandera == 1) {
        this.banderaEliminar = false;
      } else {
        this.banderaEliminar = true;
      }
    },
    eliminarImagen() {
      let me = this;
      me.dialog = false;
      me.dialogBorrarImagen = false;
      const borrar = storage
        .child(me.numeroAsistenciaDescargar + "/" + me.nombreImagen)
        .delete()
        .then(function() {
          console.log("eliminado con exito!");
          me.listaArchivos = [];
          me.contarArchivosDescarga();
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    descargarZIP() {
      let me = this;
      var FileSaver = require("file-saver");
      var JSZip = require("jszip");
      var zip = new JSZip();
      let imagenes = zip.folder("imagenes");

      for (var i = 0; i < me.imagenesPreview.length; i++) {
        let nombre = me.imagenesPreview[i].name;
        let url = me.imagenesPreview[i].url;
        let contentP = me.downloadURLPromise(url);
        imagenes.file(nombre, contentP);
      }
      zip.generateAsync({ type: "blob" }).then(function(content) {
        FileSaver.saveAs(content, "imagenes.zip");
      });
    },
    downloadURLPromise(url) {
      return new Promise(function(resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.open("GET", url);
        xhr.responseType = "blob";
        xhr.onreadystatechange = function(evt) {
          if (xhr.readyState === 4) {
            if (xhr.status == 200) {
              resolve(xhr.response);
            } else {
              reject(new Error("Error" + ":" + xhr.status));
            }
          }
        };
        xhr.send();
      });
    },
  },
};
</script>
